<div class="messages">
  @for (message of messages; track identify($index, message)) {
    <div class="message">
      <skypro-message
        [message]="message"
        [bigAttachmentPreview]="bigAttachmentPreview"
      ></skypro-message>
    </div>
  }
</div>
